module.exports = __webpack_public_path__ + "9027a4706003af4e93f4b894376507f8.png";